import { Box, Skeleton, Stack, Typography } from '@mui/material';
import {
	rootSx,
	titleContainerSx,
	titleSX,
} from '@/components/blocks/ProductCarousel/styles/productCarousel';
import {
	slidesContainerSx,
	slideSx,
} from '@/components/blocks/ProductCarousel/styles/productCarouselSkeleton';

export const ProductCarouselSkeleton = ({ slides = 3 }: { slides?: number }) => (
	<Box sx={rootSx}>
		<Stack direction="row" spacing={0} sx={titleContainerSx}>
			<Skeleton>
				<Typography variant="body1AsH1" sx={titleSX}>
					{'Product Carousel Title'}
				</Typography>
			</Skeleton>
		</Stack>

		<Box sx={slidesContainerSx}>
			{new Array(slides).fill(null).map((_, i) => (
				<Skeleton key={i} variant="rounded" sx={slideSx} />
			))}
		</Box>
	</Box>
);
